import React from "react";
import { MessageSquareText } from "lucide-react";

import { Textarea } from "../../../components/ui/textarea";

import Bloco from "../../ofertas-do-dia/admin/regras/Bloco";

const SUGESTOES = [
  "Descontraído e próximo, com no máximo 1 emoji",
  "Educado e direto ao ponto, sem gírias",
  "Divertido e animado, com emojis de comida",
  "Acolhedor, como um atendente de bairro que conhece o cliente",
];

export default function SecaoTom({ tom, onMudar }) {
  return (
    <Bloco icone={MessageSquareText} titulo="Jeito de falar da CLEO" corIcone="bg-amber-500/15 text-amber-500"
      subtitulo="Como a sua loja fala com os clientes. A CLEO segue esse tom em toda mensagem de recuperação.">
      <Textarea value={tom} maxLength={300} rows={3} onChange={(e) => onMudar(e.target.value)} data-e2e="tom-cleo"
        placeholder="Ex.: descontraído e próximo, chama o cliente pelo nome, no máximo 1 emoji" />
      <div className="flex items-center justify-between gap-2 mt-2">
        <div className="flex flex-wrap gap-1.5">
          {SUGESTOES.map((s) => (
            <button key={s} type="button" onClick={() => onMudar(s)}
              className={`rounded-full border px-2.5 py-1 text-[11px] font-medium transition-colors ${tom === s ? "border-amber-500 bg-amber-500/10" : "hover:border-amber-500/50"}`}>
              {s.split(",")[0]}
            </button>
          ))}
        </div>
        <span className="text-[11px] text-muted-foreground tabular-nums shrink-0">{tom.length}/300</span>
      </div>
    </Bloco>
  );
}
